import Vue from "vue";
import Router from "vue-router";
import kitchenManage from '@/router/kitchenManage'
import warning from '@/router/warning'
import camera from "@/router/camera";

const _import = file => () => import('@/views/' + file + '.vue')
const _import2 = file => () => import('@/components/' + file + '.vue')
Vue.use(Router);

const routerMap = [{
        path: '/',
        name: 'home',
        component: _import('home'),
        // redirect: '/kitchenManage/school',
        children:[
            ...kitchenManage,//后厨管理
            ...warning,//预警管理
            ...camera // 明厨亮照
        ],
    },
    {
        path: '/login',
        name: 'login',
        component: _import('login')
    },
    {
        path: '/login1',
        name: 'login1',
        component: _import('login1')
    },
    {
        path: '/example',
        name: 'example',
        component: _import2('example')
    }

];
export default routerMap;